<ng-container *transloco="let t; prefix: 'login'">
  <div class="card">
    <div class="card-header bg-white">
      <h5 class="mb-0">
        <button
          (click)="toggleCollapse()"
          class="btn btn-link text-secondary text-decoration-none p-0 w-100 text-start d-flex justify-content-between align-items-center"
          type="button"
          [attr.aria-expanded]="!isCollapsed()"
        >
          {{ t('legacyLoginTitle') }}
          <i
            class="fas transition-transform"
            [class.fa-chevron-down]="isCollapsed()"
            [class.fa-chevron-up]="!isCollapsed()"
          ></i>
        </button>
      </h5>
    </div>
    @if (!isCollapsed()) {
      <div class="card-body">
        <p>{{ t('legacyLoginText') }}</p>
        <div class="text-center">
          <button
            class="btn btn-default"
            pmtLoadingButton
            [loading]="isLoading()"
            [disabled]="disabled()"
            (click)="loginButtonClicked.emit()"
          >
            {{ t('legacyLoginButtonText') }}
          </button>
        </div>
      </div>
    }
  </div>
</ng-container>
